import axios from 'axios'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
import { api, env } from '@/api/env'
import {
  Loading
} from 'element-ui'

let loading, needLoadingRequestCount = 0
let longchatToken = Cookies.get('accountTo') || localStorage.getItem('longchat-token')

// get param from url
function getQuery(qryStr) {
  var reg = new RegExp('(^|&)' + qryStr + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  return r != null ? unescape(r[2]) : null
}

let axiosConfigParam = {}

if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
  axiosConfigParam = {
    ...axiosConfigParam,
    baseURL: ''
  }
}

let service = axios.create(axiosConfigParam)

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.url.includes('engineServer') || config.url.includes('/pass')) {

      loading = Loading.service({
        lock: true,
        text: '加载中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(225, 225, 225, 0.5)'
      })
    }
    // loadingInstance = Loading.service({ fullscreen: true })
    if (
      window.location.host.includes('localhost:808') ||
      window.location.host.startsWith('127.0.0.1:808')
    ) {
      const devUser = getQuery('user') || getQuery('usercode')
      // 无 user/usercode 时勿拼接字面量 "null"，否则会盖过 sessionStorage 里的 token
      if (env === 'test' && devUser) {
        const lxToken = `oSYzbUWLiruvzsEJ4uZxb9sek8PAdIDt-${devUser}`
        longchatToken = longchatToken || lxToken
      }
    }
    const account = localStorage.getItem('account') || ''
    const agToken = localStorage.getItem('ag-token') || ''
    const longchatHeader =
      sessionStorage.getItem('longchat-token') ||
      longchatToken ||
      localStorage.getItem('longchat-token') ||
      ''
    config.headers.common = {
      'Content-Type': 'application/json',
      'longchat-token': longchatHeader,
      'account': account,
      'ag-token': agToken,
    }
    return config
  },
  error => {
    // loadingInstance.close()
    if (document.getElementsByClassName('el-message').length === 0) {
      Message.error({
        message: '加载超时'
      })
    }
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  response => {
    if (response.config.url.includes('engineServer') || response.config.url.includes('/pass')) {
      loading.close()
    }
    const result = response.data
    // loadingInstance.close()
    if (result.code !== 0) {
      if (result.code == 100) {
        return result
      }
    }
    // if (result.code === 401) {
    //   debugger;
    //   if (document.getElementsByClassName('el-message').length === 0) {
    //     Message.error({
    //       message: result.msg || '请求失败'
    //     })
    //   }
    //   let url = result.data
    //   if (window.location.href.includes('process=1') && window.location.href.includes('unfinished=1')) {
    //     url = url + '?process=1&unfinished=1'
    //     url = url.split('service=')[0] + 'service=' + encodeURIComponent(url.split('service=')[1])
    //   }
    //   if (location.host.includes('todo.platanus.com')) {
    //     window.location.href = 'https://sso.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
    //   }else if (location.host.includes('todo-pre.platanus.com')) {
    //     window.location.href = 'https://sso-pre.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
    //   } else if (location.host.includes('todo-uat.platanus.com')) {
    //     window.location.href = 'https://sso-uat.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
    //   } else if(location.host.includes('todo-pc-sit-usa.platanus.com')){
    //     window.location.href = 'https://sso-sit-usa.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
    //   } else{
    //     window.location.href = url
    //   }
    // }
    return result
  },
  error => {
    // loading.close()
    const status = error.response && error.response.status
    const isLocalHost =
      location.hostname === 'localhost' || location.hostname === '127.0.0.1'

    // 本地开发：SSO Cookie 域与 localhost 不一致，登录回来仍 401，跳转 SSO 会死循环 —— 仅提示，不跳 SSO
    if (status === 401 && isLocalHost) {
      if (document.getElementsByClassName('el-message').length === 0) {
        Message.error({
          message:
            '本地未通过认证（401）。请在地址栏增加 token 参数，或设置 localStorage 的 account、ag-token（与 SIT 环境一致），勿使用 SSO 回跳 localhost。'
        })
      }
      return Promise.reject(error)
    }

    if (document.getElementsByClassName('el-message').length === 0 && status !== 401) {
      Message.error({
        message: '服务器开小差了'
      })
    }
    if (status === 401) {
      if (location.host.includes('todo-pc-usa.platanus.com')) {
        window.location.href = 'https://sso-usa.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
      } else if (location.host.includes('todo-pc-dev.platanus.com')) {
        window.location.href = 'https://sso-dev.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
      } else if (location.host.includes('todo-pc-pre-usa.platanus.com')) {
        window.location.href = 'https://sso-pre-usa.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
      } else if (location.host.includes('todo-pc-uat-usa.platanus.com')) {
        window.location.href = 'https://sso-uat-usa.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
      } else if (location.host.includes('todo-pc-sit-usa.platanus.com')) {
        window.location.href = 'https://sso-sit-usa.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
      } else {
        window.location.href = 'https://sso-usa.platanus.com/public/login?requestUrl=' + encodeURIComponent(location.href)
      }
    }
    return Promise.reject(error)
  }
)

export default service
